import requestUtils from 'api/requestUtils'
import qs from 'qs'
import { paths } from '@luxuryescapes/contract-business'

type EmployeeOrdersResponse = paths['/api/business-traveller/businesses/{businessId}/orders/employee']['get']['responses'][200]['content']['application/json']
type EmployeeOrdersSort = 'orderItemStart'
type SortDirection = 'asc' | 'desc'

interface Params {
  businessId: string;
  timeframe: 'upcoming' | 'past' | 'cancelled' | 'qualificationWindow';
  page: number;
  limit: number;
  sort?: EmployeeOrdersSort;
  sortDirection?: SortDirection;
  // Filter orders by if the requester is a booking manager, traveller or both
  filterBy?: 'bookingManager' | 'traveller' | 'all';
}

async function requestGetEmployeeOrders(params: Params) {
  const { businessId, timeframe, page, limit, sort, sortDirection, filterBy } = params

  const queryParams = qs.stringify({
    timeframe,
    page,
    limit,
    sort,
    sortDirection,
    filterBy,
  })

  try {
    const { result: orders, meta } = await requestUtils.get<EmployeeOrdersResponse>(
      `/api/business-traveller/businesses/${businessId}/orders/employee?${queryParams}`,
      { credentials: 'include', excludeBrand: true },
    )

    return {
      orders,
      meta,
    }
  } catch(error: any) {
    if (error?.status === 404) {
      return Promise.reject('No orders found')
    }
    return Promise.reject('Something went wrong')
  }
}

export default requestGetEmployeeOrders
